export const pirateCollectionId = "game.piratenation.piratenft";
export const shipsCollectionId = "game.piratenation.tradeablegameitems";
export const gameItemsCollectionId = "game.piratenation.tradeableshipnft";

export const collectionIds = { pirates: pirateCollectionId, ships: shipsCollectionId, items: gameItemsCollectionId };

export const CDN_GATEWAY_URL = 'https://ipfs.proofofplay.gg/ipfs/'
export const IPFS_GATEWAY_URL = 'https://ipfs.io/ipfs/'

export const GAME_URL = process.env.NEXT_PUBLIC_BASE_URL ?? 'piratenation.game'
export const MARKETPLACE_SOURCE = process.env.NEXT_PUBLIC_PUBLIC_ENVIRONMENT === 'testnet' ? "testnet.marketplace.proofofplay.com" : "marketplace.proofofplay.com";
export const SHIP_TYPE_FILTER = "Pirate's";
export const MAX_QUANTITY_PURCHASE = 10;
export const DISABLED_TOKEN_ID_SWEEPS = [609];
